import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { Observable, of, timer } from 'rxjs'
import { catchError, first, map, switchMap } from 'rxjs/operators'
import { ContentUnitService } from '../services/content-unit.service'
import { GlobalErrorService } from '@services/global-error.service'

export function contentUnitExistsValidator(
  contentUnitService: ContentUnitService,
  globalErrorService: GlobalErrorService,
  initialValue: string | null = null,
  debounceTimeMs?: number
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value as unknown

    if (typeof value !== 'string' || value.trim() === '') {
      return of(null)
    }

    const titleToCheck = value.trim()

    if (initialValue !== null && titleToCheck === initialValue.trim()) {
      return of(null)
    }

    return timer(debounceTimeMs ?? 300).pipe(
      switchMap(() => contentUnitService.checkContentUnitExists(titleToCheck)),
      map(exists => (exists ? { contentUnitExists: true } : null)),
      catchError(() => {
        globalErrorService.reportError({
          subsystemName: 'Content Unit Title Validator',
          description: 'Could not validate if content unit title exists. Please try again.'
        })
        return of(null)
      }),
      first()
    )
  }
}
